import styled from 'styled-components';
import Parent from '../Base/style';
const MessageContainer = styled(Parent)``;

export default MessageContainer;
